module.exports = __webpack_public_path__ + "img/Support white.1612aa92.svg";